import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import useIsGlobetrotter from '../../hooks/useIsGlobetrotter.js';
import { Rating as Rating$2, Plus } from './Rating.style.js';
import cardTexts from '../Card/Card.texts.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import useGlobals from '../../hooks/useGlobals.js';
import Icon from '../Icon/Icon.js';
import { UI_LOGO } from '../../icons/UI_LOGO.js';
import { UI_LOGO_CIRCLE } from '../../icons/UI_LOGO_CIRCLE.js';

var _excluded = ["rating", "size", "responsive"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Rating = function Rating(_ref) {
  var rating = _ref.rating,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'm' : _ref$size,
    _ref$responsive = _ref.responsive,
    responsive = _ref$responsive === void 0 ? false : _ref$responsive,
    rest = _objectWithoutProperties(_ref, _excluded);
  var isGlobetrotter = useIsGlobetrotter();
  var _useGlobals = useGlobals(),
    culture = _useGlobals.culture;
  var ariaLabelText = cardTexts[culture].standard;
  if (typeof rating !== 'number') {
    return false;
  }
  if (rating < 2 || rating > 11) {
    return false;
  }
  var ratings = [];
  for (var i = 0; i < Math.floor(rating / 2); i += 1) {
    ratings.push(/*#__PURE__*/jsx(Icon, {
      "aria-hidden": "true",
      path: isGlobetrotter ? UI_LOGO : UI_LOGO_CIRCLE
    }, i));
  }

  // TODO: Add aria-label with rating in text form
  var getAriaLabel = function getAriaLabel() {
    var ratingValue = Math.floor(rating / 2);
    var hasPlus = rating % 2 === 1;
    return "".concat(ariaLabelText, " ").concat(ratingValue).concat(hasPlus ? '+' : '');
  };
  return /*#__PURE__*/jsxs(Rating$2, _objectSpread(_objectSpread({
    role: "img",
    $responsive: responsive,
    $size: size,
    $hasPlus: rating % 2 === 1,
    "aria-label": getAriaLabel()
  }, rest), {}, {
    children: [ratings, rating % 2 === 1 && /*#__PURE__*/jsx(Plus, {
      "aria-hidden": "true",
      children: "+"
    })]
  }));
};
var Rating$1 = Rating;

export { Rating$1 as default };
//# sourceMappingURL=Rating.js.map
